<template>
  <FeatureFlagSwitcher :flag="Feature_Flags.PORTAL_LOYALTY_REVAMP">
    <template #new>
      <LoyaltyEnhancedTiers />
    </template>
    <template #old>
      <LoyaltyTiers />
    </template>
  </FeatureFlagSwitcher>
</template>

<script>

import LoyaltyEnhancedTiers from './V2/components/Tiers.vue';
import LoyaltyTiers from './components/Tiers.vue';
import { Feature_Flags } from '@/enums/globals';

export default {
  name: 'LoyaltyTiersFlagSwitcher',
  components: {
    LoyaltyEnhancedTiers,
    LoyaltyTiers,
  },
  data() {
    return { Feature_Flags };
  }
};
</script>
